import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isProduction: boolean;
}

const PlaceOfDeliveryConsumptionSimplifiedHeader = ({ isProduction }: Props) => {
  // translations
  const tLabels = useTranslation("placeOfDelivery\\placeOfDelivery").t;

  // helpers
  const getConsumptionTitle = () => { 
    if (isProduction) {
      return tLabels("placeOfDeliveryConsumptionSimplifiedHeader.production");
    } else {
      return tLabels("placeOfDeliveryConsumptionSimplifiedHeader.consumption");
    }
  }

  // render
  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-center">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className="col-sm">
                <span className="d-none d-lg-inline">{tLabels("placeOfDeliveryConsumptionSimplifiedHeader.placeOfDeliveryName.desktop")}</span>
                <span className="d-lg-none">{tLabels("placeOfDeliveryConsumptionSimplifiedHeader.placeOfDeliveryName.mobile")}</span>
            </div>
            <div className="col-sm text-sm-center">
              <span>{tLabels("placeOfDeliveryConsumptionSimplifiedHeader.planConsumption")} </span>
              <span className="d-none d-lg-inline">{getConsumptionTitle()} </span>
              <small>[MWh]</small>
            </div>
            <div className="col-sm text-sm-center">
              <span>{tLabels("placeOfDeliveryConsumptionSimplifiedHeader.realConsumption")} </span>
              <span className="d-none d-lg-inline">{getConsumptionTitle()} </span>
              <small>[MWh]</small>
            </div>
          </div>
        </div>
        <div className="col-auto">
        </div>
      </div>
    </div>
  );
}

export default PlaceOfDeliveryConsumptionSimplifiedHeader;